<template>
  <div class="bg-backend flex flex-col justify-between min-h-screen">
    <div>
      <top-layout-navigation />
      <div id="underTheNav" />
      <tw-container class="mt-8">
        <router-view :key="$route.path" v-slot="{ Component }">
          <component :is="Component" :key="'viewer-' + $route.path" />
        </router-view>
      </tw-container>
    </div>
    <tw-container class="pb-6 pt-8">
      <grouprev-public-footer />
    </tw-container>
  </div>
</template>

<script>
import Navigation from '@/components/TopNavigation.vue'
import OrganizationRegisterModal from '@/components/organizations/organization-register-modal.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import GrouprevPublicFooter from '@/components/grouprev-public-footer.vue'
import TopLayoutNavigation from '@/components/backend/top-layout-navigation.vue'

export default {
  name: 'BackendPages',
  components: { TopLayoutNavigation, GrouprevPublicFooter, TwContainer, OrganizationRegisterModal, Navigation },
}
</script>
